import { usePermissions } from '@hetivo/hetivo-lib-front-utils';
import { MODULE_AREA } from '@hetivo/hetivo-lib-types';

import { useTenantModules } from '&/hooks/use-tenant-modules';

import { INSPECTIONS_LIST_PERMISSION } from '../paths';
import { useInspectionStats } from './use-inspection-stats';
import { useInspectionScope } from './use-inspections-page';

/**
 * The number of Due inspections for the selected scope, for the sidebar badge (SWOOP-400, FR-012). It reads the
 * page's own stats query (`useInspectionStats`, keyed on the master selector alone), so the badge and the Due tab
 * always agree (SC-003, research R8). Enabled only when the tenant owns Inspections and the user has
 * `inspections:list`; otherwise it never runs and returns `undefined` (no entry, no request). It also returns
 * `undefined` while loading and when the request fails, so the menu shows no badge rather than a false 0.
 */
export function useInspectionsDueCount(): number | undefined {
  const { hasPermission } = usePermissions();
  const { hasModule } = useTenantModules();
  const criteria = useInspectionScope();

  const enabled = hasModule(MODULE_AREA.Inspections) && hasPermission(INSPECTIONS_LIST_PERMISSION);

  return useInspectionStats(criteria, enabled).data?.tabs.due;
}
